import { RefObject } from 'react'

/**
 * Prevent blur on high resolution displays
 * */
const scaleCanvas = (width: number, height: number, ref: RefObject<HTMLCanvasElement>) => {
  const scale = window.devicePixelRatio

  const scaledWidth = Math.floor(width * scale)
  const scaledHeight = Math.floor(height * scale)
  const shouldScale = height !== scaledHeight

  const canvas = ref.current
  const ctx = canvas.getContext('2d')

  canvas.width = scaledWidth
  canvas.height = scaledHeight
  canvas.style.width = width + 'px'
  canvas.style.height = height + 'px'

  ctx.save()
  if (shouldScale) ctx.scale(scale, scale)
}

const chartsUtils = { scaleCanvas }
export default chartsUtils
